export default __webpack_public_path__ + "static/media/hard_drive_ca.feab9712.svg";